
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/museums",
      function () {
        return require("private-next-pages/museums/index.tsx");
      }
    ]);
  